import NiceDomain from "@/domains/communityTalk/niceDomain";

export default class ReplyController {
	private readonly _niceDomain: NiceDomain;

	/**
	 * コンストラクタ。
	 */
	constructor() {
		this._niceDomain = new NiceDomain();
	}

	/**
	 * トークルーム投稿の、いいね投稿APIへのリクエスト。
	 * @param tenantId テナントID
	 * @param tagCd コミュニティトークのタグコード
	 * @param talkRoomId いいね対象のトークルームID
	 * @param publishCookieId ReviCoCookieId。
	 * @param tenantMemberCd テナントサイトの会員コード
	 */
	public async postTalkRoomNice(tenantId?: string, tagCd?: string, talkRoomId?: string, publishCookieId?: string, tenantMemberCd?: string): Promise<string> {
		// Null許容不可能な値がNullである場合、Error
		if (!tenantId) {
			throw new Error("tenantId: value not exist.");
		}
		if (!tagCd) {
			throw new Error("tagCd: value not exist.");
		}
		if (!talkRoomId) {
			throw new Error("talkRoomId: value not exist.");
		}
		if (!publishCookieId) {
			throw new Error("publishCookieId: value not exist.");
		}

		try {
			return await this._niceDomain.postNiceData(tenantId, tagCd, "TalkRoom", talkRoomId, publishCookieId, tenantMemberCd);
		} catch (e) {
			throw new Error();
		}
	}

	/**
	 * リプライ投稿の、いいね投稿APIへのリクエスト。
	 * @param tenantId テナントID
	 * @param tagCd コミュニティトークのタグコード
	 * @param replyId いいね対象のリプライID
	 * @param publishCookieId ReviCoCookieId。
	 * @param tenantMemberCd テナントサイトの会員コード
	 */
	public async postReplyNice(tenantId?: string, tagCd?: string, replyId?: string, publishCookieId?: string, tenantMemberCd?: string): Promise<string> {
		// Null許容不可能な値がNullである場合、Error
		if (!tenantId) {
			throw new Error("tenantId: value not exist.");
		}
		if (!tagCd) {
			throw new Error("tagCd: value not exist.");
		}
		if (!replyId) {
			throw new Error("replyId: value not exist.");
		}
		if (!publishCookieId) {
			throw new Error("publishCookieId: value not exist.");
		}

		try {
			return await this._niceDomain.postNiceData(tenantId, tagCd, "Reply", replyId, publishCookieId, tenantMemberCd);
		} catch (e) {
			throw new Error();
		}
	}
}
